import { useFacilities } from "@/hooks/useFacilities";

export const useFacility = (id: number | undefined) => {
    const { facilities, isLoading, isResolved, error } = useFacilities();

    const facility = facilities?.find((facility) => facility.id === id);

    return { facility, isLoading, isResolved, error };
};
